/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarContact_user = {|
  +isVerifiedTrade: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarContact_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
